/** 本人確認書類区分（nttpc_client_identifications.id_document_type） */
export enum IdDocumentTypeEnum {
  /** 運転免許証 */
  DriversLicense = "11",
  /** マイナンバーカード */
  MyNumberCard = "12",
  /** 在留カード */
  ResidenceCard = "13",
  /** 特別永住者証明書 */
  SpecialPermanentResident = "15",
}

export const ID_DOCUMENT_TYPE_LABELS: Record<IdDocumentTypeEnum, string> = {
  [IdDocumentTypeEnum.DriversLicense]: "運転免許証",
  [IdDocumentTypeEnum.MyNumberCard]: "マイナンバーカード",
  [IdDocumentTypeEnum.ResidenceCard]: "在留カード",
  [IdDocumentTypeEnum.SpecialPermanentResident]: "特別永住者証明書",
};

export function getIdDocumentTypeLabel(code: string | null | undefined): string {
  if (!code) {
    return "提出書類未選択 (電子本人確認未実施)";
  }
  const label = ID_DOCUMENT_TYPE_LABELS[code as IdDocumentTypeEnum];
  return label ?? code;
}

/**
 * アップロードファイル種別（nttpc_client_identification_files.file_type）
 */
export enum IdentificationEnum {
  /** 身分証明書（表面）— 個人・法人共通で必須 */
  IdentificationFront = 1,
  /** 身分証明書（裏面）— 任意 */
  IdentificationBack = 2,
  /** 補助書類 — 任意 */
  IdentificationSupplementary = 3,
  /** 履歴事項全部証明書 — 法人のみ */
  RegistryCertificate = 4,
  /** 印鑑証明書 — 法人のみ */
  SealCertificate = 5,
  /** 委任状 — 法人・担当者手続き時など */
  PowerOfAttorney = 6,
}

// 本人確認情報編集画面の戻り先
export enum IdentificationEditReturnTo {
  Clients = 'clients',
  Identifications = 'identifications',
}

export enum VerificationMethod {
  manual = "manual",
  ekyc = "ekyc",
}

export function getVerificationMethodLabel(method: VerificationMethod): string {
  switch (method) {
    case VerificationMethod.manual:
      return "手動";
    case VerificationMethod.ekyc:
      return "eKYC";
    default:
      return method;
  }
}

export enum VerificationStatus {
  not_submitted = "not_submitted",
  submitted = "submitted",
  verified = "verified",
  deficiency = "deficiency",
  cancel = "cancel",
}

export function getVerificationStatusLabel(status: VerificationStatus): string {
  switch (status) {
    case VerificationStatus.not_submitted:
      return "未提出";
    case VerificationStatus.submitted:
      return "提出済";
    case VerificationStatus.verified:
      return "確認済";
    case VerificationStatus.deficiency:
      return "不備";
    case VerificationStatus.cancel:
      return "認証エラー";
    default:
      return status;
  }
}

export function getVerificationStatusVariant(
  status: VerificationStatus
): "default" | "secondary" | "destructive" | "outline" {
  switch (status) {
    case VerificationStatus.not_submitted:
      return "outline";
    case VerificationStatus.submitted:
      return "secondary";
    case VerificationStatus.verified:
      return "default";
    case VerificationStatus.deficiency:
      return "destructive";
    case VerificationStatus.cancel:
      return "destructive";
    default:
      return "outline";
  }
}
